// eslint-disable-next-line i18next/no-literal-string -- category ids matched against the API's category ids
export const EDITABLE_SPRINGBOARD_CATEGORY_IDS = ['plan', 'create', 'scale', 'deliver'] as const;

export type EditableSpringboardCategoryId = (typeof EDITABLE_SPRINGBOARD_CATEGORY_IDS)[number];

export const SPRINGBOARD_CATEGORY_LABEL_MAX_LENGTH = 100;
export const SPRINGBOARD_CATEGORY_SUBTITLE_MAX_LENGTH = 255;
export const SPRINGBOARD_CATEGORY_DESCRIPTION_MAX_LENGTH = 2000;
